(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusiveBookingModification',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $saved_cards        = $form.find('.credit-cards'),
		    $saved_cards_parent = $saved_cards.parents('.form-group');

		$saved_cards.on('change', function fetchCCData() {
			Adzuki.Ajax.get('/ClientCreditCards/get/'+$(this).val()+'/1/1')
			.then(function fillBillingInfo(cc_info)
			{
				var $cc_number    = $('#allinclusivebookingmodification-payment-number'),
				    num_token     = (cc_info.number_token ? cc_info.number_token : null),
				    $ccv_number   = $('#allinclusivebookingmodification-payment-cvv'),
				    ccv_token     = (cc_info.ccv_token ? cc_info.ccv_token : ''),
				    secure_tokens = [];

				if (num_token === null) {
					$cc_number.removeAttr('data-token');
					$ccv_number.removeAttr('data-ccv_token');

					$cc_number.val('').focus();
					$ccv_number.val('');
				} else {
					$cc_number.attr('data-token', num_token);
					$ccv_number.attr('data-ccv_token', ccv_token);

					secure_tokens[0] = num_token;

					if (ccv_token !== '') {
						secure_tokens[1] = ccv_token;
					}

					Adzuki.SecureStorage.detokenize({
						secure_storage_tokens: secure_tokens,
						success              : function success(plain_texts) {
							$cc_number.val(plain_texts[0]);

							if (plain_texts.length === 2) {
								$ccv_number.val(plain_texts[1]);
							}
						}
					});
				}

				$("#allinclusivebookingmodification-payment-name_on_card").val(cc_info.name);
				$("#allinclusivebookingmodification-payment-credit_card_type").val(cc_info.credit_card_sabre_code);
				$("#allinclusivebookingmodification-payment-address1").val(cc_info.address1);
				$("#allinclusivebookingmodification-payment-address2").val(cc_info.address2);
				$("#allinclusivebookingmodification-payment-city").val(cc_info.city);
				$("#allinclusivebookingmodification-payment-state").val(cc_info.state_iso);
				$("#allinclusivebookingmodification-payment-zip").val(cc_info.zip);
				$("#allinclusivebookingmodification-payment-expiration").data('DateTimePicker').date(moment(cc_info.expiration));
			});
		});

		fetchClientCreditCards($('#allinclusivebookingmodification-client_id').val());

		function fetchClientCreditCards(client_id) {
			Adzuki.Ajax.get('/ClientCreditCards/getCardsByClientId/'+client_id+'/1/1')
			.then(function fillClientCCs(cc_data)
			{
				if (!$.isEmptyObject(cc_data)) {
					$.each(cc_data, function populateCCSelect(sKey, sValue) {
						$saved_cards.append($('<option>').text(sValue).attr('value', sKey));
					});
					$saved_cards_parent.removeClass('hidden');
				}
			});

			Adzuki.Ajax.get('/Clients/getPhoneNumbers/'+client_id)
			.then(function fillClientPhone(phone_data) {
				$('#allinclusivebookingmodification-payment-phone').val(phone_data.primary);
			});

			Adzuki.Ajax.get('/Clients/getClientEmail/'+client_id)
			.then(function fillClientEmail(email_data) {
				$('#allinclusivebookingmodification-payment-email').val(email_data[client_id]);
			});
		}
	};
}(jQuery, window.Adzuki || {}));